import React, { useState, useEffect } from "react";
import img1 from '../imgs/tha (1).png';
import img2 from '../imgs/tha (2).png';
import img3 from '../imgs/tha (3).png';
import img4 from '../imgs/tha (4).png';
import img5 from '../imgs/tha (5).png';
import '../css/vasanthamaligaidetails.css'

const slides = [
  {
    src: img1, 
    caption: "Vasanthamaligai – Title Card",
  },
  {
    src: img2,
    caption: "Synopsis – A Dream Home Awaits",
  },
  {
    src: img3,
    caption: "Format – Family Freeze Challenge",
  },
  {
    src: img4,
    caption: "Road To Vasantha Maligai Episode",
  },
];


const details = [
  {
    heading: "Synopsis",
    content:
      "A vibrant family entertainment game show where contestants take part in exciting and fun-filled challenges to win household prizes and move one step closer to owning their dream home, Vasantha Maligai.",
    type: "text",
  },
  {
    heading: "Production",
    content: "© Lotus Meta Entertainment | All Rights Reserved",
    type: "text",
  },
];

export const VasanthamaligaiDetail = ({ onBack }) => {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
 
  const goTo = (index) => {
    if (animating || index === current) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setAnimating(false);
    }, 300);
  };
 
  const prev = () => goTo((current - 1 + slides.length) % slides.length);
  const next = () => goTo((current + 1) % slides.length);
 
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
 
  return (
    <div className="vd-page">
      {/* Back */}
      <button className="vd-back-btn" onClick={onBack}>
        ← Back to Projects
      </button>
 
      {/* Header */}
      <div className="vd-header">
        <h1 className="vd-title">Vasanthamaligai</h1>
        <p className="vd-subtitle">
           Lotus Meta Entertainment
      &nbsp;|&nbsp; <strong> All Rights Reserved</strong>   </p>
      </div>
 
      {/* Slideshow */}
      <div className="vd-slideshow-wrapper">
        <button className="vd-nav-btn vd-nav-btn--left" onClick={prev}>
          ‹
        </button>
 
        <div className="vd-slide-container">
          <img
            src={slides[current].src}
            alt={slides[current].caption}
            className={`vd-slide-img ${animating ? "vd-slide-img--fade" : ""}`}
          />
          <div className="vd-caption-bar">
            <span>{slides[current].caption}</span>
          </div>
        </div>
 
        <button className="vd-nav-btn vd-nav-btn--right" onClick={next}>
          ›
        </button>
      </div>
 
      {/* Dot Indicators */}
      <div className="vd-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`vd-dot ${i === current ? "vd-dot--active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>
 
      {/* Detail Cards */}
      <div className="vd-details">
        {details.map((item, i) => (
          <div className="vd-detail-card" key={i}>
            <h2 className="vd-detail-heading">{item.heading}</h2>
            {item.type === "text" ? (
              <p className="vd-detail-text">{item.content}</p>
            ) : (
              <ul className="vd-detail-list">
                {item.items.map((point, j) => (
                  <li key={j}>{point}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};